import Utils from "../services/utils-service.js";
import Vehicle from "../services/vehicle-service.js";
import Funnel from "../services/funnel-service.js";
import router from "../router.js";
import { throwError } from "../errors";

export default {
    state: {
        ymmt: ['year', 'make', 'model', 'trim'], //YMMT waterfall executes in order from index 0-3
        ymmtCtrl: []
    },
    getters: {
        ymmt: state => state.ymmt,
        ymmtCtrl: state => state.ymmtCtrl
    },
    mutations: {
        setYmmt(state, ymmt) {
            state.ymmt = ymmt;
        },
        resetYmmtCtrl(state) {
            state.ymmtCtrl = [];
        },
        addYmmtCtrl(state, ymmtCtrl) {
            for (const f of ymmtCtrl.split(',')) {
                state.ymmtCtrl.push(f.trim());
            }
        }
    },
    actions: {
        createVehicleElem(context, data) {
            $.ajax({
                type: 'POST',
                url: '/api?req=auto&action=add-vehicle',
                data: data.payload,
                beforeSend: function () {
                    context.commit('SET_SAVING_STATUS', true);
                },
                success: function (res) {
                    console.log('Vehicle created ', res);
                    if (!Utils.isEmpty(res) && Object.keys(res).length > 0) {
                        if (Object.keys(res.data).length > 0) {
                            const fs = new Funnel({ ctx: context });
                            fs.commitMutations(res.data);
                        }
                        if (Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {

                                const veh = new Vehicle({ ctx: context });
                                const vehCount = veh.getVehiclesCount();
                                veh.createVehicleAdHocSeq(vehCount);

                                context.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_new_vehicle', key: 'loading', val: false });
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    context.commit('SET_SAVING_STATUS', false);
                },
                error: function () {
                    context.commit('SET_SAVING_STATUS', false);
                }
            });
        },
        editVehicleElem(context, data) {
            console.log('editVehicleElem: data', data);
            $.ajax({
                type: 'POST',
                url: '/api?req=auto&action=edit-vehicle',
                data: data,
                beforeSend: function () {
                    context.commit('SET_SAVING_STATUS', true);
                },
                success: function (res) {
                    console.log('Vehicle edited ', res);
                    if (!Utils.isEmpty(res) && Object.keys(res).length > 0 && res.error === undefined) {
                        if (Object.keys(res.data).length > 0) {
                            const fs = new Funnel({ ctx: context });
                            fs.commitMutations(res.data);
                        }
                        if (Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    context.commit('SET_SAVING_STATUS', false);
                },
                error: function () {
                    context.commit('SET_SAVING_STATUS', false);
                }
            });
        },
        deleteVehicleElem(context, data) {
            console.log('deleteVehicleElem: data', data);
            $.ajax({
                type: 'POST',
                url: '/api?req=auto&action=delete-vehicle',
                data: data,
                beforeSend: function () {
                    context.commit('SET_SAVING_STATUS', true);
                },
                success: function (res) {
                    console.log('Vehicle deleted ', res);
                    if (res != null && Object.keys(res).length > 0 && res.error === undefined) {
                        if (Object.keys(res.data).length > 0) {
                            const fs = new Funnel({ ctx: context });
                            fs.commitMutations(res.data);
                        }
                        if (Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    context.commit('SET_SAVING_STATUS', false);
                },
                error: function () {
                    context.commit('SET_SAVING_STATUS', false);
                }
            });
        },
        processVINValidate(context, data) {
            const uid = 'in_vin';
            if (!data.vin) {
                console.log('VIN is missing: ', data);
                return;
            }
            $.ajax({
                type: 'POST',
                url: '/api?req=auto&action=vin-lookup',
                data: data,
                beforeSend: function () {
                    context.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
                    context.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'loading', val: true });
                },
                success: function (res) {
                    console.log('VIN Look up result: ', res);
                    context.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'loading', val: false });

                    if (!Utils.isEmpty(res) && Object.keys(res).length > 0) {

                        if (res.message != 'VIN Not Found')
                            context.commit('UPDATE_FACTORY_ITEMS', { disable_next: false });

                        if (Object.keys(res.data).length > 0) {
                            const fs = new Funnel({ ctx: context });
                            fs.commitMutations(res.data);
                        }
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    const errObj = {
                        errorLocation: "processVINValidate",
                        xhr: JSON.stringify(xhr),
                        textStatus: textStatus,
                        errorThrown: errorThrown,
                        data: JSON.stringify(data)
                    };

                    throwError(new Error(`Something went wrong while fetching VIN data.`), errObj);

                    console.log('%c Something went wrong while fetching VIN data!', 'background: #222; color: red');
                    context.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
                    context.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'loading', val: false });
                }
            });
        },
        processVINDiscovery(context, data) {
            const uid = data.rsrc != 'vehicle_detail' ? `in_${data.rsrc}` : 'in_trim';

            $.ajax({
                type: 'POST',
                url: '/api?req=auto&action=vin-discovery',
                data: data,
                beforeSend: function () {
                    if (context.getters.ymmt.indexOf(data.rsrc) != -1 || data.rsrc == 'vehicle_detail') {
                        context.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'loading', val: true });
                    }
                },
                success: function (res) {
                    console.log('VIN discovery result: ', res);
                    //TODO: Add error response for empty arrary response.
                    if (context.getters.ymmt.indexOf(data.rsrc) != -1 || data.rsrc == 'vehicle_detail') {
                        context.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'loading', val: false });
                    }

                    const vehicle = new Vehicle({ ctx: context });

                    if (res != null && Object.keys(res).length > 0) {

                        vehicle.resetVehFieldAndOptions({ req: data, res: res });

                        const iuid = vehicle.vehPropStr(data.rsrc);

                        if (context.getters.funnel.elements[iuid] && !Utils.isEmpty(context.getters.funnel.elements[iuid].value)) {
                            vehicle.vinDiscovery(data.rsrc, data.veh);
                        }
                        if (data.rsrc == 'vehicle_detail') {
                            vehicle.setVehicleDetail(res);
                        }
                    }
                },
                error: function () { }
            });
        }
    }
}